import React from 'react';
import { Card, Col, ColProps } from 'react-bootstrap';

import { InsurancePolicy } from '@models/InsurancePolicy';
import { QuotePremiumCardBody } from '@components/Feature/Quote';

type Props = Pick<ColProps, 'children'> & {
  policy: InsurancePolicy
};

const RightCol = ({ children, policy }: Props) => {
  if (!policy) return null;

  return (
    <Col lg>
      <Card className="mb-4">
        <QuotePremiumCardBody {...policy} planName={policy.benefitTemplate.name} />
        {children}
      </Card>
    </Col>
  );
};

export { RightCol };
